import React, { useCallback, useContext } from 'react'
import SectionFormContainer from '../../../components/SectionFormContainer'
import GroomingAppointmentWizardContext from '../GroomingAppointmentWizardContext'
import { Checkbox, makeStyles } from '@material-ui/core'
import { FONT_WEIGHTS } from '../../../../../utils'

const useStyles = makeStyles(() => ({
	root: { display: 'flex', flexDirection: 'column', flex: 1, width: '55%', gap: '2rem', alignItems: 'center' },
	subtextContainer: {
		textAlign: 'center',
		fontFamily: 'Nunito',
		fontSize: '0.875rem',
		fontWeight: FONT_WEIGHTS.SemiBold
	},
	formContainer: { display: 'flex', flex: 1, width: '80%', gap: '.75rem', marginTop: '1rem' },
	checkBoxContainer: {
		'& .MuiCheckbox-root': {
			padding: 0
		}
	},
	policyTextContainer: {
		fontFamily: 'Nunito',
		fontSize: '0.875rem',
		fontWeight: FONT_WEIGHTS.SemiBold
	}
}))

const CancelationPolicy = (props) => {
	const classes = useStyles()
	const {
		wizardContextProvider: { grooming_appointment, setWizardAttributeAndValues }
	} = useContext(GroomingAppointmentWizardContext)
	const { visit_attr, subtext = '', title = '' } = props

	const handleSelection = useCallback(
		(e) => {
			if (e.target && e.target.checked !== undefined) {
				const newValues = { ...grooming_appointment }
				newValues[visit_attr] = e.target.checked
				setWizardAttributeAndValues(newValues)
			}
		},
		[grooming_appointment, setWizardAttributeAndValues, visit_attr]
	)

	return (
		<SectionFormContainer title={title}>
			<div className={classes.root}>
				<div className={classes.subtextContainer}>{subtext}</div>
				<div className={classes.formContainer}>
					<div className={classes.checkBoxContainer}>
						<Checkbox onChange={handleSelection} checked={grooming_appointment[visit_attr] === true} />
					</div>
					<div className={classes.policyTextContainer}>
						By checking this box, I understand that cancellation is free if I cancel before 6:00pm two
						days before the appointment. Cancellations made after 6:00pm two days before the
						appointment but before 9:00am one day before will incur a fee of 20% of your base service
						cost. Cancellations made after 9:00am one day before the appointment or no-shows will incur
						a fee of 50% of your base service cost.
					</div>
				</div>
			</div>
		</SectionFormContainer>
	)
}

export default CancelationPolicy
